import classNames from 'classnames';
import { FC } from 'react';
import styles from './TabMenuFilter.module.scss';

interface ListItemTypes {
  name: string;
  key: string;
  count?: number;
}

type TabMenuFilterProps = {
  setActive?: any;
  active: string;
  lists?: ListItemTypes[];
  count?: boolean;
  indicator?: string[];
  disabled?: boolean;
  orders?: boolean;
  operations?: boolean;
  employeds?: boolean;
  fullWidth?: boolean;
};

export const TabMenuFilter: FC<TabMenuFilterProps> = ({
  setActive,
  active,
  lists = [
    { name: 'Сделки', key: 'deals' },
    { name: 'Платежи', key: 'payments' },
    { name: 'Налоги', key: 'taxes' },
  ],
  count,
  indicator = [],
  disabled = false,
  orders,
  operations,
  employeds,
  fullWidth = false,
}) => {
  const handlerActive = (item: ListItemTypes | any) => {
    if (count) {
      if (employeds) localStorage.setItem('employedsFilter', item.key);

      setActive(item);
    } else {
      if (orders) localStorage.setItem('ordersFilter', item.key);
      if (operations) localStorage.setItem('operationsFilter', item.key);

      setActive(item.key);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.root} style={fullWidth ? { width: '100%' } : {}}>
        {lists.map((item: ListItemTypes, i: number) => (
          <div
            className={classNames(styles.item, item.key === active ? styles.active : '')}
            key={i}
            onClick={() => (!disabled ? handlerActive(item) : undefined)}
            style={fullWidth ? { width: '100%', justifyContent: 'center' } : {}}>
            <p>{item.name}</p>
            {count ? <span>{item.count}</span> : null}
            {!!item.count && indicator.includes(item.key) ? (
              <div className={styles.indicator} />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};
